module.exports = __webpack_public_path__ + "media/images/social/vv_07-8e266cfcf15cdb0a8045e7f01b81b84d.jpg";